/**
 * @class model for all enums in the system
 */
export class Enum{
    id:number;
    name:string;
    alias?:string;
}